module.exports = __webpack_public_path__ + "static/media/2fa.059366d6.png";